class KVKSlider {
  constructor(e, t, i) {
    ((this.selector = $(e)), (this.callback = i), (this.carouselSettings = t), this.initializeCorousel());
  }
  sliderCallback() {
    this.callback && this.callback();
  }
  initializeCorousel() {
    this.selector.owlCarousel({
      loop: this.carouselSettings?.loop || !1,
      dots: this.carouselSettings?.dots || !1,
      margin: this.carouselSettings?.margin || 10,
      items: this.carouselSettings?.items || 3,
      nav: this.carouselSettings?.nav || !1,
      navText: this.carouselSettings?.navText,
      autoplay: this.carouselSettings?.autoplay || !1,
      autoplayTimeout: this.carouselSettings?.autoplayTimeout || 5e3,
      responsiveClass: this.carouselSettings?.responsiveClass || !0,
      responsive: this.carouselSettings?.responsive || {
        0: { items: 1, nav: !0 },
        600: { items: 3, nav: !1 },
        1e3: { items: 5, nav: !0, loop: !1 },
      },
      onInitialize: this.sliderCallback(),
    });
  }
}
class KVKJs {
  constructor() {
    ((this.mobileCartSelector = document.querySelector('[data-ajax-cart-toggle-class-button="js-my-cart-open2"]')),
      this.mobileCartSelector?.addEventListener('click', this.onMobileCartClick),
      (this.showMoreButtonSelector = document.querySelector('.show_image_button')),
      this.showMoreButtonSelector?.addEventListener('click', this.onShowMoreButtonSelectorClick),
      (this.sizeChartSelector = document.querySelector('#MySizeChartPopUp')),
      this.sizeChartSelector?.addEventListener('click', this.onSizeChartSelectorClick),
      (this.sizeChartCloseSelector = document.querySelector('#SizeChartPopUp .close')),
      this.sizeChartCloseSelector?.addEventListener('click', this.onSizeChartCloseSelectorClick),
      this.onCartPageReady(),
      this.onBodyReady(),
      this.priceFilterFunction());
  }
  onMobileCartClick(e) {
    (e.preventDefault(),
      $('.mm-ocd.mm-ocd--left').removeClass('mm-ocd--open'),
      $('body').removeClass('mm-ocd-opened'),
      $('body').addClass('js-my-cart-open'));
  }
  onShowMoreButtonSelectorClick(e) {
    (e.preventDefault(), $('.product__media-list').toggleClass('show-all-images'));
  }
  onSizeChartSelectorClick(e) {
    (e.preventDefault(),
      $('body').addClass('bg-body'),
      $('#SizeChartPopUp').toggle(),
      $('body').css('padding-right', '5px'),
      $('body').css('overflow', 'hidden'));
  }
  onSizeChartCloseSelectorClick(e) {
    (e.preventDefault(),
      $('body').removeClass('bg-body'),
      $('#SizeChartPopUp').hide(),
      $('body').css('padding-right', '0px'),
      $('body').css('overflow', 'inherit'));
  }
  onCartPageReady() {
    setTimeout(function () {
      if (
        $('.totals__subtotal-value .limoniapps-discountninja-shortcode').hasClass(
          'limoniapps-discountninja-shortcode-discounted_price',
        )
      ) {
        var e;
        let t = (
          45 -
          $(
            '.limoniapps-discountninja-shortcode.limoniapps-discountninja-shortcode-discounted_price .money.geolizr-currency',
          ).attr('data-geolizr-price') /
            100
        ).toFixed(2);
        ($('#aec_left_value').text(t),
          parseFloat(t) >= 0
            ? ($('#aec_value').hide(), $('#aec_value_free').show(), $('#aec_shipping_label').show())
            : ($('#aec_value').show(), $('#aec_value_free').hide(), $('#aec_shipping_label').show()));
      } else $('#aec_shopify_shipping').css('display', 'block');
    }, 1e4);
  }
  onBodyReady() {
    if (
      (setInterval(function () {
        var e = $('#shopify-section-header').height();
        $('#shopify-section-header').hasClass('shopify-section-header-hidden')
          ? ($('#main-cart-footer').addClass('cart-footer-top'), $('#main-cart-footer').css('top', '0'))
          : ($('#main-cart-footer').removeClass('cart-footer-top'), $('#main-cart-footer').css('top', e));
      }, 100),
      (e = setInterval(function () {
        $('.nosto_element > div').hasClass('row') &&
          ($('.nosto_element .nosto-block .product_after_shop_loop_buttons ').addClass('hide'),
          $('.nosto_element .nosto-block .products-grid ').addClass('card-wrapper'),
          $('.nosto_element .nosto-block .product_thumbnail').addClass('card--product'),
          $('.eva_product_quick_view_button').addClass('quick_view_link'),
          $('.eva_product_quick_view_button').attr('href', 'javascript:void(0);'),
          $('.eva_product_quick_view_button').removeAttr('onclick'),
          clearInterval(e));
      }, 500)),
      $('.color-img-outer .item.item-img-outer').length > 5 &&
        $('.color-img-outer').addClass('main-pdp-Slider owl-carousel owl-theme'),
      $('.fhLinks ul li').length > 8)
    )
      767 >= $(window).width() && $('.fhLinks ul').addClass('main-col-Slider owl-carousel owl-theme');
    else {
      var e;
      767 >= $(window).width() && $('.fhLinks ul').addClass('main-col-Slider owl-carousel owl-theme');
    }
  }
  priceFilterFunction() {
    (priceFilters(), priceFilterClicks());
  }
}
function priceFilters() {
  if (
    window.location.href.indexOf('&filter.v.price.gte') > -1 ||
    window.location.href.indexOf('?filter.v.price.gte') > -1
  ) {
    (($.urlParam = function (e) {
      return RegExp('[?&]' + e + '=([^&#]*)').exec(window.location.href)[1] || 0;
    }),
      0.99 != (e = $.urlParam('filter.v.price.gte')) && (e = Math.floor(e)));
    var e,
      t = e + '-' + $.urlParam('filter.v.price.lte');
    ($('.facets__list--price li').each(function (e) {
      t == $(this).children().data('price')
        ? $(this).children().children('input').prop('checked', !0)
        : $(this).children().children('input').prop('checked', !1);
    }),
      $('.mobile-facets__list--price li').each(function (e) {
        t == $(this).children().data('price')
          ? $(this).children().children('input').prop('checked', !0)
          : $(this).children().children('input').prop('checked', !1);
      }));
  }
}
function priceFilterClicks() {
  ($(document).on('click', '.facets__list--price label', function () {
    if ($(this).children('input').is(':checked'))
      ($(this).children('input').prop('checked', !1),
        $('#Filter-Price-GTE').attr('max', ''),
        $('#Filter-Price-LTE').attr('min', ''),
        $('#Filter-Price-GTE').val(''),
        $('#Filter-Price-LTE').val(''),
        $('#active-price-facets__button')[0].click());
    else {
      ($(this).parent().siblings().children().children('input').prop('checked', !1),
        $(this).children('input').prop('checked', !0));
      var e = $(this).data('price');
      ((priceValue1 = (e = e.split('-'))[0]),
        (priceValue2 = e[1]),
        $('#Filter-Price-GTE').attr('max', priceValue2),
        $('#Filter-Price-LTE').attr('min', priceValue1),
        $('#Filter-Price-GTE').val(priceValue1),
        $('#Filter-Price-LTE').val(priceValue2));
    }
  }),
    $(document).on('click', '.mobile-facets__list--price label', function () {
      if ($(this).children('input').is(':checked'))
        ($(this).children('input').prop('checked', !1),
          $('#Mobile-Filter-Price-GTE').attr('max', ''),
          $('#Mobile-Filter-Price-LTE').attr('min', ''),
          $('#Mobile-Filter-Price-GTE').val(''),
          $('#Mobile-Filter-Price-LTE').val(''),
          $('#Mobile-active-price-facets__button')[0].click());
      else {
        ($(this).parent().siblings().children().children('input').prop('checked', !1),
          $(this).children('input').prop('checked', !0));
        var e = $(this).data('price');
        ((priceValue1 = (e = e.split('-'))[0]),
          (priceValue2 = e[1]),
          $('#Mobile-Filter-Price-GTE').attr('max', priceValue2),
          $('#Mobile-Filter-Price-LTE').attr('min', priceValue1),
          $('#Mobile-Filter-Price-GTE').val(priceValue1),
          $('#Mobile-Filter-Price-LTE').val(priceValue2));
      }
    }));
}
function callbackpom() {
  $('#pom-pom').parent().removeClass('hidden');
}
function callbackCollection() {
  $('.collection-hero').removeClass('no-slider');
}
function changeSort(e) {
  ($('#SortBy').val(e), document.getElementById('FacetFiltersForm').dispatchEvent(new Event('input', { bubbles: !0 })));
}
function scrollToTop() {
  return (window.scrollTo(0, 0), !1);
}
function initShowMore() {
  var e = document.getElementById('show_image_button');
  'Show less images' === e.innerHTML ? (e.innerHTML = 'Load more images') : (e.innerHTML = 'Show less images');
}
function copyFunction() {
  var e = document.createElement('input'),
    t = window.location.href;
  (document.body.appendChild(e),
    (e.value = t),
    e.select(),
    document.execCommand('copy'),
    document.body.removeChild(e),
    (document.getElementById('copy-product').innerHTML =
      '<svg id="pol" fill="#000" widh="24px" height="24px" viewBox="0 0 50 50" version="1.1" xmlns="http://www.w3.org/2000/svg" role="img" aria-labelledby="77f1f905-2b4a-40c4-a986-018c45572add"><title id="77f1f905-2b4a-40c4-a986-018c45572add">Tick</title><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><polygon fill="#000" fill-rule="nonzero" points="14.6553946 35.392902 5.19935444 25.8272493 0 31.0869305 12.4784711 43.7100827 12.4927896 43.6954946 14.7708631 46 50 10.3619014 44.6998024 5"></polygon></g></svg>'),
    (document.getElementById('svg-text').innerHTML = 'Copied'));
}
(!(function (e) {
  var t = e('#promotion__text').html();
  e('.collection-hero .collection-hero__description .text-sales .des-text').after(t);
})(jQuery),
  $(window).scroll(function () {
    $(this).scrollTop() > 50 ? $('.scrollToTop').fadeIn() : $('.scrollToTop').fadeOut();
  }),
  (function (e) {
    if ('product' == KVKData.templateData && KVKData.productData.variants.length > 1) {
      var t = 'tags=' + KVKData.productData.tags;
      e.ajax({
        url: 'https://reports-justhype.aec-clients.co.in/sizechart',
        data: t,
        processData: !1,
        contentType: 'application/x-www-form-urlencoded',
        type: 'POST',
        dataType: 'json',
        success: function (t) {
          if (null != t.data) {
            var i = t.data.data;
            (e('#size-chart').append(i), e('#sizeChartButtonWrapper').show());
          }
        },
        error: function (t) {
          e('#sizeChartButtonWrapper').hide();
        },
      });
    }
  })(jQuery),
  $(document).ready(function () {
    (new KVKJs(),
      new KVKSlider(
        '#pom-pom',
        {
          loop: !0,
          margin: 10,
          dots: !1,
          navText: ['', ''],
          responsiveClass: !0,
          responsive: {
            0: { items: 1, nav: !0 },
            600: { items: 3, nav: !1, loop: !1 },
            1e3: { items: 5, nav: !0, loop: !1 },
          },
        },
        callbackpom,
      ),
      new KVKSlider(
        '.main-col-Slider',
        {
          loop: !0,
          dots: !1,
          margin: 5,
          items: 8,
          nav: !0,
          touchDrag: !0,
          mouseDrag: !0,
          responsiveClass: !0,
          responsive: {
            0: { items: 2 },
            640: { items: 3 },
            767: { items: 4 },
            1e3: { items: 6 },
            1100: { items: 8 },
            1800: { items: 12 },
          },
        },
        callbackCollection,
      ),
      new KVKSlider('.main-pdp-Slider', {
        loop: !0,
        margin: 5,
        items: 5,
        nav: !0,
        autoplay: !0,
        autoplayTimeout: 2e3,
        responsiveClass: !0,
        responsive: {
          0: { items: 5 },
          640: { items: 5 },
          767: { items: 8 },
          1e3: { items: 5 },
          1100: { items: 5 },
          1800: { items: 5 },
        },
      }),
      new KVKSlider('.owl-carousel'));
  }));
